<template>
    <div>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="输入等级名称进行检索" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="创建时间" prop="date">
                    <el-date-picker
                        v-model="query.date"
                        type="daterange"
                        align="left"
                        unlink-panels
                        range-separator="-"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('dlgl_djpz_xz')">
                <el-button size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="序号" align="center" type="index" width="100" />
                <el-table-column label="等级名称" align="center" prop="name" />
                <el-table-column label="创建时间" align="center" prop="create_time" />
                <el-table-column v-if="permission('dlgl_djpz_bj') || permission('dlgl_djpz_sc')" label="操作" align="center" width="100">
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('dlgl_djpz_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                        <el-button v-if="permission('dlgl_djpz_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <DialogVue ref="dialog" @update="search"></DialogVue>
    </div>
</template>

<script>
import { list, del } from "@/api/proxy/level";
import { startDate, endDate } from "@/pages/config";
import listMixin from "@/mixins/list";
import DialogVue from "./dialog.vue";

export default {
    components: { DialogVue },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
                date: [],
            },
            module: "等级",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            const params = {
                ...this.query,
                search_start_time: this.query.date && this.query.date[0] ? startDate(0, this.query.date[0]) : null,
                search_end_time: this.query.date && this.query.date[1] ? endDate(0, this.query.date[1]) : null,
            };
            delete params.date;
            this._search(params);
        },
        handleAdd() {
            this.$refs.dialog.open();
        },
        handleEdit(row) {
            this.$refs.dialog.open(row);
        },
    },
};
</script>
